import { render, staticRenderFns } from "./EditBasicPoll.vue?vue&type=template&id=eb2714f8&scoped=true&"
import script from "./EditBasicPoll.vue?vue&type=script&lang=ts&"
export * from "./EditBasicPoll.vue?vue&type=script&lang=ts&"
import style0 from "./EditBasicPoll.vue?vue&type=style&index=0&id=eb2714f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2714f8",
  null
  
)

export default component.exports